import { render, staticRenderFns } from "./detailsNew.vue?vue&type=template&id=6058b938&scoped=true&"
import script from "./detailsNew.vue?vue&type=script&lang=js&"
export * from "./detailsNew.vue?vue&type=script&lang=js&"
import style0 from "./detailsNew.vue?vue&type=style&index=0&id=6058b938&lang=scss&scoped=true&"
import style1 from "./detailsNew.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6058b938",
  null
  
)

export default component.exports